<template>
    <div :class="hasLongButtonText ? 'grid grid-cols-2 auto-cols-max gap-2.5': 'flex flex-wrap flexbox-gap-hack-wrapper'">
        <text-button
            v-for="option in buttonOptions"
            :key="option.value"
            :input-name="optionName"
            :input-value="option.value"
            :input-label="option.label"
            :selected-value="selectedValue"
            :is-disabled="option.hidden || !option.available"
            @valueChange="updateSelectedValue(option, $event)"
            :class="hasLongButtonText ? 'leading-tight': 'flexbox-gap-hack-item'"
        />
    </div>
</template>

<script>
    import TextButton from './TextButton.vue';

    export default {
        components: {
            TextButton,
        },

        props: {
            optionName: {
                type: String,
                required: true,
            },
            options: {
                type: Array,
                required: true,
            },
            selectedValue: {
                type: String,
                required: false,
            },
            hasLongButtonText: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            buttonOptions() {
                return this.options || [];
            },
        },

        methods: {
            updateSelectedValue(option, value) {
                this.$emit('selectionChanged', {
                    option,
                    value,
                });
            },
        },
    };
</script>
